import { useNavigate } from 'react-router-dom'

export const TRANSFER_URL = '/assembly/detail/:transferId/:docNum/transfer'

export const useGoToTransfer = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string, docNum: string) => {
      navigate(
        TRANSFER_URL.replace(':transferId', transferId).replace(
          ':docNum',
          docNum
        )
      )
    }
  }
}
